// キャンセル済み案件への案内 (ADR-0055 Decision 3)。UploadPage (verify 未通過) と
// Wizard (submit 時点で判明) の両方から同じ文言・画面で使う。
export function CampaignAbortedNotice() {
  return (
    <section className="rounded-lg border border-border bg-card p-6 shadow-sm">
      <h1 className="text-base font-semibold">この実施はキャンセルされました</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        この実施は取りやめとなったため、名簿のアップロードは行えません。ご不明な点は WFJ
        担当者にお問い合わせください。
      </p>
    </section>
  );
}
